<style>

.container{
  display: grid;
  grid-template-columns: 35px auto 32px;
  align-self: center;
  justify-self: center;
  text-align: center;
}
.flag{
  grid-column: 1;
}
.country{
  grid-column: 2;
  padding-top: 4px;
}
.arrow{
  grid-column: 3;
  font-size: 23px;
}

.flags{
  width: 29px;
}
</style>

<div class="container" on:click="{ () => dispatch('showDialog') }">
  <div class="flag">
    <img src="flags/circle-flags:{countries[code].code}.svg" alt="" class="flags">
  </div>
  <div class="country">{countries[code].name}</div>
  <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

// country code
export let code = "us";

let countries = {
  "us": {name: "United States", code: "us"}, 
  "id": {name: "Indonesia", code: "id"},
}

</script>